// imports
import Underline from "./images/under-line.svg";
import TwitterIcon from "./images/twitter-footer-icon.svg";
import DiscordIcon from "./images/discord-footer-icon.svg";
import InstagramIcon from "./images/instagram-footer-icon.svg";
import Frame_7 from "./images/Frame-7.svg";
import brown_cat from "./images/brown-cat-2.svg";
import cat from "./images/cat.svg";
import ClipperPng from "./images/Clipper.png";
import Undeline from "./images/Undeline.svg";
import golden from "./images/golden.svg";
import opensea from "./images/opensea.svg";
import underline_vertical from "./images/Undeline-vertical.svg";
import arrow_down from "./images/Vector-down.svg";
import winner_avatar from "./images/winner-avatar-listed.png";
import paw from "./images/paw.png";

import CatOnePng from "./images/cat-1.png";
import CatTwoPng from "./images/cat-2.png";
import CatThreePng from "./images/cat-3.png";
import CatFourPng from "./images/cat-4.png";
import CatFivePng from "./images/cat-5.png";
import success_1 from "./images/Success_1.png";
import success_2 from "./images/Success_2.png";
import success_3 from "./images/success_3.png";

import bg_cat from "./images/bg_cat.jpg";
import group_1 from "./images/group_1.svg";
import city_bg_Blue from "./images/city-bg-Blue.png";
import avatar from "./images/Avatar.svg";
import admin_avatar from "./images/admin-avatar.png";
import admin_avatar_2 from "./images/admin-avatar-off.png";
import pixelated_cat from "./images/cat-pixelated.png";
import border from "./images/border.png";
import walking_cats from "./images/walking-cats.png";
import minted_bg from "./images/minted-bg.png";
import cat1 from "./images/cat1.png";
import cat2 from "./images/cat2.png";
import cat3 from "./images/cat3.png";
import cat4 from "./images/cat4.png";
import cat5 from "./images/cat5.png";
import Admin_status from "./images/adminOnlineStatus.png";

const static_cat = "https://static.displate.com/857x1200/displate/2019-11-14/66cef9af4684ed3dda7e8878cbe8307e_e9789d059091758f8453d49130877d77.jpg"

const blinking_cat = "https://d1lu1ykcmin7ci.cloudfront.net/blinking-cat.gif";

const HeroImgPng = "https://d1lu1ykcmin7ci.cloudfront.net/HeroImg.png";

const HowToExport = "https://d1lu1ykcmin7ci.cloudfront.net/how-to-export.svg";

const Caseboard_Colored =
  "https://d1lu1ykcmin7ci.cloudfront.net/Caseboard_Colored_09162022.png";

// exports
export {
  Caseboard_Colored,
  HowToExport,
  Underline,
  TwitterIcon,
  DiscordIcon,
  InstagramIcon,
  Frame_7,
  brown_cat,
  cat,
  ClipperPng,
  Undeline,
  golden,
  opensea,
  underline_vertical,
  arrow_down,
  HeroImgPng,
  CatOnePng,
  CatTwoPng,
  CatThreePng,
  CatFourPng,
  CatFivePng,
  success_1,
  success_2,
  success_3,
  blinking_cat,
  bg_cat,
  group_1,
  city_bg_Blue,
  avatar,
  pixelated_cat,
  border,
  walking_cats,
  minted_bg,
  cat1,
  cat2,
  cat3,
  cat4,
  cat5,
  admin_avatar,
  winner_avatar,
  paw,
  admin_avatar_2,
  Admin_status,
  static_cat
};
